import React from 'react';
import { Card } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStyles } from '../../../../../Components/helper';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';

function MultiSingleSizePackUnit({ data, fromAddEdit, forSwitch, lengthEnabled }) {
  const { t } = useTranslation('common');

  return (
    <Card className="card-margin-bottom rounded-0 pb-3">
      <Card.Header className="bgcolor-dark rounded-0">
        <div className="d-flex flex-wrap align-items-center p-2">
          <div className="custom-control custom-switch">
            <input
              type="checkbox"
              className="custom-control-input"
              id="multiSingleSizeSwitch"
              name="multiSingleSizeSwitch"
              onChange={forSwitch}
              disabled={!fromAddEdit}
              checked={data?.visible?.multiple}
            />
            <label className="custom-control-label" htmlFor="multiSingleSizeSwitch">
              <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.MULTI_SINGLE_SIZE')}</strong>
            </label>
          </div>
          <div className="date my-2 my-md-0 pr-3 ml-md-auto">
            <div className="input-button-container bg-white">
              <CustomDatePicker
                dateFormat="dd/MM/yyyy"
                name="selectedActualApproveByDate"
                popperPlace="top-end"
                placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.HANDOVER_DATE')}
                disable
              />
            </div>
          </div>
          <div className="date justify-content-end pr-1">
            <div className="input-button-container bg-white">
              <CustomDatePicker
                dateFormat="dd/MMM/yyyy"
                name="selectedActualApproveByDate"
                popperPlace="top-end"
                placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.SHIPMENT_DATE')}
                disable
              />
            </div>
          </div>
        </div>
      </Card.Header>
      {(data?.visible?.multiple || fromAddEdit) && (
        <Card.Body>
          <div className="table-responsive">
            <table className="table custom-table xs-layout-fixed font-13 mb-5">
              <thead>
                <tr>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.SIZE_COLUMN_HEADER')}</th>
                  {lengthEnabled && <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.LENGTH_COLUMN_HEADER')}</th>}
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.PACK_RATIO_COLUMN_HEADER')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.TOTAL_PACKS_COLUMN_HEADER')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.TOTAL_UNITS_COLUMN_HEADER')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.PRICE_BEFORE_DISCOUNT_COLUMN_HEADER')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.DISCOUNT_PERCENT_COLUMN_HEADER')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.PRICE_AFTER_DISCOUNT_COLUMN_HEADER')}</th>
                </tr>
              </thead>
              <tbody>
                <tr key={0}>
                  <td>
                    <div className="custom-react-select">
                      <Select name="Size" isDisabled styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" placeholder="" />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" isDisabled placeholder="" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.MULTI_TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.MULTI_TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTOFILLED_TEXT')}</strong>
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.ENTER_PRICE_BEFORE_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.DISCOUNT_PER_UNIT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.PRICE_AFTER_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                </tr>
                <tr key={1}>
                  <td>
                    <div className="custom-react-select">
                      <Select name="Size" isDisabled styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" placeholder="" />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" isDisabled placeholder="" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.ENTER_TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.ENTER_TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTOFILLED_TEXT')}</strong>
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.ENTER_PRICE_BEFORE_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.DISCOUNT_PER_UNIT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.PRICE_AFTER_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                </tr>
                <tr key={2}>
                  <td>
                    <div className="custom-react-select">
                      <Select name="Size" isDisabled styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" placeholder="" />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" styles={customStyles} maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" isDisabled placeholder="" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT._TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT._TEXTS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <strong> {t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTO_FILLED')} </strong>
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.PRICE_BEFORE_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.PER_UNIT_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AFTER_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                </tr>

                <tr key={3}>
                  <td colSpan={lengthEnabled ? 9 : 8}>
                    <strong className="d-flex align-item-center justify-content-center">
                      {t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.TOTAL_TITLE')}
                    </strong>
                  </td>
                </tr>
                <tr key={4}>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTOFILLED')}</strong>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTOFILLED')}</strong>
                    </td>
                  )}
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTOFILLEDS')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTOFILLEDS')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTO')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTO')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTO_')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.MULTI_SINGLE_SIZE_PACK_UNIT.AUTO_')}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card.Body>
      )}
    </Card>
  );
}

export default MultiSingleSizePackUnit;
